var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {}, [_c('legend', [_vm._v("ScanTally Report")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm1.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Batch ID :")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BatchID),
      expression: "BatchID"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('BatchID')
    },
    attrs: {
      "name": "BatchID",
      "placeholder": "Enter BatchID"
    },
    domProps: {
      "value": (_vm.BatchID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BatchID = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipping IDs :")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShippingId),
      expression: "ShippingId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter ShippingId",
      "name": "ShippingId",
      "id": "ShippingId"
    },
    domProps: {
      "value": (_vm.ShippingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShippingId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sample-awb-eg col-md-12"
  }, [_c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ShippingId')),
      expression: "errors.has('form-1.ShippingId')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.ShippingId')))])])]), _vm._v(" "), _c('div', {
    staticClass: "sample-awb-eg col-md-12"
  }, [_c('div', [_vm._v(" Multiple shipping IDs can be separated using comma or next line (,/↵).")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("Search")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger leftmar",
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" Reset ")])])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTables),
      expression: "showTables"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('legend', [_vm._v(" ScanTally F/W ")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "overflow-x": "scroll"
    }
  }, [_c('h6', {
    staticClass: "header-label1"
  }, [_vm._v("ShipmentScanTallyMaster Summary : ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sr No.")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("BatchID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("HubID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("BatchType")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("StartTime")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CreatedDate")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CreatedBy")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CloseTime")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("LastModifiedDate")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("LastModifiedBy")])])])]), _vm._v(" "), _c('tbody', [(_vm.ScantallyMasterData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ScantallyMasterData.BatchID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ScantallyMasterData.HubID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ScantallyMasterData.BatchType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ScantallyMasterData.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("changeDateFormat")(_vm.ScantallyMasterData.StartTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("changeDateFormat")(_vm.ScantallyMasterData.CreatedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ScantallyMasterData.CreatedBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("changeDateFormat")(_vm.ScantallyMasterData.CloseTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("changeDateFormat")(_vm.ScantallyMasterData.LastModifiedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ScantallyMasterData.LastModifiedBy))])])])]), _c('br'), _vm._v(" "), _c('h6', {
    staticClass: "header-label1"
  }, [_vm._v("ShipmentScanTally Summary : ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sr No.")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShippingID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("BatchID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current HubID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Notification Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Delivery Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("IsInscan")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("IsOverage")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("IsUpdatedLater")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Comments")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("LastProcessDate")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CreatedBy")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CreatedDate")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("LastModifiedBy")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("LastModifiedDate")])])])]), _vm._v(" "), _c('tbody', [(_vm.ScantallyData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._l((_vm.ScantallyData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.BatchID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CurrentHubId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NotificationType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DeliveryStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.IsInscan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.IsOverage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.IsUpdatedLater))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Comments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.LastProcessDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CreatedBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("changeDateFormat")(data.CreatedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.LastModifiedBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("changeDateFormat")(data.LastModifiedDate)))])])
  })], 2)]), _c('br'), _vm._v(" "), _c('h6', {
    staticClass: "header-label1"
  }, [_vm._v("ScanTallyShipment Summary : ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sr No.")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Request")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShippingID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Notification Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Notification Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current HubID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("UserProcess")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("uniquecode")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ActionStatusId")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("checkstatuscode")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("OutSourcingMasterId")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Comments")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("LastModifiedDate")])])])]), _vm._v(" "), _c('tbody', [(_vm.ScantallyShipmentData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "14",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._l((_vm.ScantallyShipmentData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Request))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NotificationType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NotificationStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CurrentHubId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.UserProcess))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.uniquecode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ActionStatusId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.checkstatuscode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.OutSourcingMasterId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Comments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("changeDateFormat")(data.LastModifiedDate)))])])
  })], 2)]), _c('br')], 1)])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0478d215","hasScoped":true}!./src/views/components/ScanTally/ScanTallyReport/ScanTallyReport.component.html
// module id = 1402
// module chunks = 1